"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.googleMapsApiKey = void 0;
exports.googleMapsApiKey = process.env.NEXT_PUBLIC_BOS_GOOGLE_MAPS_API_KEY;
//# sourceMappingURL=env-variables.js.map